<script>
import WObjTypeFilter from '@/components/table/PhysicalObjTable/ObjTypeFilter';
import { isEqual, isEmpty, filter } from 'lodash';
import managetypeKeyApi from '@/api/model/managetype-key';

export default {
  name: 'WRootCauseObjTypeFilter',
  extends: WObjTypeFilter,
  methods: {
    /**
      * 관리 구분 키 정보를 로드한다. - 함수를 오버라이드하여 NMS의 경우 ND만을 보여주도록 수정
      * 2019. 10. 21 => NMS의 경우 장비로 고정, managetypeKey select박스  숨김처리
      *
      * @author Song
      * @return {[type]} [description]
      */
    loadManagetypeKey(managetypeId) {
      managetypeKeyApi
        .getDisplayedManagetypeKeyList(managetypeId)
        .then((response) => {
          if (!isEmpty(response.data) && response.data.success === true && !isEmpty(response.data.data)) {
            this.isRootCause = false;
            if (isEqual(managetypeId, 'VMS')) {
              this.managetypeKeyList = filter(response.data.data, (item) => item.managetypeKey !== '_');
            } else if (isEqual(managetypeId, 'NMS')) {
              this.managetypeKeyList = [];
              this.managetypeKeyList.push(response.data.data[0]);
              this.managetypeKey = 'ND';
              this.isRootCause = true;
            } else {
              this.managetypeKeyList = response.data.data;
            }
            this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
          } else {
            this.managetypeKeyList = null;
            this.managetypeKey = null;
          }
        })
        .catch(() => {
          this.managetypeKeyList = null;
          this.managetypeKey = null;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/RootCauseEventSettings/components/RootCauseObjTypeFilter.vue